// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  resultId: __t.u64().primaryKey().name("result_id"),
  workspaceId: __t.u64().name("workspace_id"),
  commitSha: __t.string().name("commit_sha"),
  source: __t.string(),
  context: __t.string(),
  status: __t.string(),
  url: __t.string(),
  summary: __t.string(),
  receivedAt: __t.i64().name("received_at"),
  updatedAt: __t.i64().name("updated_at"),
});
